import { Dispatch, ReactNode, SetStateAction, useState } from 'react'
import { DragDropContext, OnDragEndResponder } from 'react-beautiful-dnd'

import { AssociationsModal } from 'src/components'
import { AssociationsType } from 'src/types'

import useStyles from './styles'
import { AssociationList } from './associations-list.component'

export interface ISelectedIcon {
  icon: string
  text: string
  id: string
  subText?: string
  locationName?: string
  aiGenerated?: boolean
}

interface Props {
  type: AssociationsType
  description: string | ReactNode
  modalTitle?: string
  selectedItems: string[]
  setSelectedItems: Dispatch<SetStateAction<string[]>> | ((value: string[]) => void)
  handleSelectItem: (value: string) => void
  selectedIcons?: ISelectedIcon[] | null
  isRound?: boolean
  withDnd?: boolean
  modalContentNode?: ReactNode
  disabled?: boolean
  disabledItemLink?: boolean
  showAccountInfo?: boolean
  hideCount?: boolean
}

const Associations = ({
  disabled,
  type,
  description,
  isRound,
  selectedItems,
  setSelectedItems,
  handleSelectItem,
  selectedIcons,
  withDnd,
  modalContentNode,
  disabledItemLink,
  showAccountInfo,
  hideCount = false,
}: Props) => {
  const classes = useStyles({ isRoundImage: isRound })
  const [open, setOpen] = useState(false)

  const handleOpenModal = () => {
    setOpen(true)
  }

  const handleCloseModal = () => {
    setOpen(false)
  }

  const handleDragEnd: OnDragEndResponder = ({ draggableId, source, destination }) => {
    if (!destination) return

    // If we are in the same position and in the same "droppable" area, then skip.
    if (destination.droppableId === source.droppableId && destination.index === source.index) return

    if (!selectedIcons) return

    const selectedIconsIds = selectedIcons.map(({ id }) => id)

    selectedIconsIds.splice(source.index, 1)
    selectedIconsIds.splice(destination.index, 0, draggableId)
    setSelectedItems(selectedIconsIds)
  }

  const selectionCount = selectedItems ? selectedItems.length : 0

  return (
    <div className={classes.bigContainer}>
      <div className={classes.text}>{description}</div>
      {!hideCount && (
        <div className={classes.textCounter}>
          {selectionCount} {type}
        </div>
      )}
      <DragDropContext onDragEnd={handleDragEnd}>
        <AssociationList
          selectedItems={selectedItems}
          disableItemLink={disabledItemLink}
          disabled={disabled}
          withDnd={!!withDnd}
          selectedIcons={selectedIcons}
          type={type}
        />
      </DragDropContext>
      <AssociationsModal
        type={type}
        open={open}
        isImageRound={isRound}
        selectedItems={selectedItems}
        handleCloseModal={handleCloseModal}
        handleSelectItem={handleSelectItem}
        modalContentNode={modalContentNode}
        showAccountInfo={showAccountInfo}
      />
      <input
        width={'100%'}
        name="image"
        accept="image/*"
        id={`id-${type}`}
        type="checkbox"
        multiple
        hidden
        onChange={handleOpenModal}
      />
    </div>
  )
}

export { Associations }
